<template>
  <div class="confirm-view">
    <b-container>
      <section class="section section--loader" v-if="loading">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-if="!loading">
        <confirm-content-block
          :reservation_id="reservation_id"
          :confirm_code="confirm_code"
          :confirm="confirm"
        />
      </section>
    </b-container>
  </div>
</template>

<script>
import { service_handler } from '@src/services'
import ConfirmContentBlock from '@booking/components/views/content-blocks/confirm.vue'
export default {
  name: 'confirm-view',

  components: {
    'confirm-content-block': ConfirmContentBlock
  },

  props: {
    reservation_id: String,
    confirm_code: String,    
  },

  data() {
    return {
      loading: true,
      confirm: {},
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
    this.get_confirm()
  },

  methods: {
    get_confirm() {
      service_handler(
        'confirm',
        {
          reservation_id: this.reservation_id,
          confirmcode: this.confirm_code
        },
      )
        .then(
          (success) => {
            setTimeout(() => {
              this.log('[confirm.vue] - success')
              this.log(success.data)
              this.confirm = success.data
              this.loading = false              
            }, 2000)
          },
          (error) => {
            this.log('[confirm.vue] - error')
            this.log(error.response)
            this.confirm = {}
            this.loading = false
          }
        )
    },
  },
}
</script>

<style lang="scss" scoped>
</style>